import axios from "axios";
import { DataGrid, DropDownBox } from "devextreme-react";
import {
  Column,
  FilterRow,
  GroupPanel,
  HeaderFilter,
  Scrolling,
  SearchPanel,
  Selection,
} from "devextreme-react/data-grid";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { updateStudyList } from "./Redux/studyList";

export default function StudyDropDownBox(props) {
  const { experienceStudiesGridRef, studyDropDownBoxRef } = props;

  const [id, setId] = useState(
    experienceStudiesGridRef.current.instance.getSelectedRowsData().length == 0
      ? null
      : Array.of(
          experienceStudiesGridRef.current.instance.getSelectedRowsData()[0].id
        )
  );
  const [isGridBoxOpened, setIsGridBoxOpened] = useState(false);
  const [dataSource, setDataSource] = useState(null);

  const studyList = useSelector((state) => state.studyList);

  const dispatch = useDispatch();

  useEffect(async () => {
    if (studyList.studyList.length == 0) {
      try {
        const result = await axios.get(
          `${process.env.REACT_APP_BECCO_API_URL}/api/cv/experienceStudies/study`
        );

        dispatch(updateStudyList(result.data));

        setDataSource(result.data);
      } catch (error) {
        console.error(error);
      }
    } else {
      setDataSource(studyList.studyList);
    }
  }, []);

  const onSelectionChanged = (e) => {
    if (e.selectedRowKeys.length > 0) {
      setId(e.selectedRowKeys);
    }

    setIsGridBoxOpened(false);
  };

  const contentRender = () => {
    return (
      <DataGrid
        keyExpr={"id"}
        dataSource={dataSource}
        hoverStateEnabled={true}
        selectedRowKeys={typeof id == "string" ? Array.of(id) : id}
        onSelectionChanged={onSelectionChanged}
        height={"100%"}
        showBorders={true}
        showColumnLines={true}
      >
        <Selection mode={"single"} />
        <Scrolling mode={"virtual"} showScrollbar="always" />

        <FilterRow visible={true} />
        <HeaderFilter visible={true} />

        <GroupPanel visible={true} />
        <SearchPanel visible={true} />

        <Column
          dataField={"APPLY_ENTP_NAME"}
          caption="임상시험 의뢰자"
          groupIndex={0}
        />
        <Column
          dataField={"APPROVAL_TIME"}
          caption="승인일"
          dataType="date"
          format="yyyy-MM-dd"
          editorOptions={{
            dateSerializationFormat: "yyyy-MM-dd",
          }}
          width={100}
        />
        <Column dataField={"GOODS_NAME"} caption="제품명" width={300} />
        <Column dataField={"CLINIC_EXAM_TITLE"} caption="시험제목" />
        <Column
          dataField={"TRGT_DISS_CD_NM"}
          caption="대상질환"
          dataType={"string"}
          width={200}
        />
        <Column dataField={"CLINIC_STEP_NAME"} caption="단계" width={100} />
      </DataGrid>
    );
  };

  const onValueChanged = (e) => {
    if (e.value) {
      studyDropDownBoxRef.current.instance.option("validationStatus", "valid");
    }
  };

  const onOptionChanged = (e) => {
    if (e.name === "opened") {
      setIsGridBoxOpened(e.value);
    }
  };

  const displayExpr = (item) => {
    if (item) {
      return `[${item.APPLY_ENTP_NAME}][${item.CLINIC_STEP_NAME}] ${item.CLINIC_EXAM_TITLE}`;
    }

    return null;
  };

  return (
    <DropDownBox
      name="id"
      ref={studyDropDownBoxRef}
      value={id}
      opened={isGridBoxOpened}
      dataSource={dataSource}
      valueExpr={"id"}
      //   displayExpr="CLINIC_EXAM_TITLE"
      displayExpr={displayExpr}
      deferRendering={false}
      placeholder="Select a value..."
      contentRender={contentRender}
      onValueChanged={onValueChanged}
      onOptionChanged={onOptionChanged}
    />
  );
}
